import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import { Fragment } from 'react'
import Code from '@/components/ui/code/code'
import { cx } from '@/utils/strings'
import { TypeComponentCode } from '@/types/ctf'

type CodeTabsProps = {
  code: TypeComponentCode<'WITHOUT_UNRESOLVABLE_LINKS'>[]
}

export default function CodeTabs({ code }: CodeTabsProps) {
  return (
    <div className="w-full">
      <TabGroup>
        <TabList className="flex flex-wrap gap-1 md:gap-2 mb-2">
          {code.map((block) => {
            return (
              <Tab as={Fragment} key={block.sys.id}>
                {({ hover, selected }) => (
                  <button
                    type="button"
                    className={cx(
                      'relative py-2 px-4 rounded-3xl text-base before:content-[""] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:rounded-3xl before:border-2 before:border-primaryBlue text-primaryBlue',
                      selected &&
                        `bg-primaryBlue text-white  before:border-none dark:bg-arctic-gradient dark:text-secondary-800`,
                      hover &&
                        `bg-midnight-gradient text-white before:border-none dark:bg-arctic-gradient dark:text-secondary-800`
                    )}
                  >
                    {block.fields.language}
                  </button>
                )}
              </Tab>
            )
          })}
        </TabList>
        <TabPanels>
          {code.map((block) => {
            return (
              <TabPanel
                key={block.sys.id}
                className="w-full [.bw-code-container]:h-[10rem] [.bw-code-container]:text-sm md:[&_.bw-code-container]:h-[clamp(10rem,50vh,38rem)] md:[.bw-code-container]:text-base"
              >
                <Code language={block.fields.language} body={block.fields.body} />
              </TabPanel>
            )
          })}
        </TabPanels>
      </TabGroup>
    </div>
  )
}
